import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiCheck } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Label } from '../../components/ui/Label';
import { Alert } from '../../components/ui/Alert';
import { AuthShell } from '../../components/auth/AuthShell';
import { Turnstile } from '../../components/Turnstile';

export function RecuperarSenhaPage() {
  const { recuperarSenha } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviado, setEnviado] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setCarregando(true);
    const { error } = await recuperarSenha(email.trim(), captchaToken ?? undefined);
    setCarregando(false);
    if (error) {
      setErro(error);
      return;
    }
    setEnviado(true);
  }

  if (enviado) {
    return (
      <AuthShell titulo="E-mail enviado">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4">
            <FiCheck size={24} />
          </div>
          <p className="text-sm text-slate-600 mb-6">
            Se houver uma conta vinculada a <strong>{email}</strong>, você receberá um link para redefinir
            a senha em alguns minutos. Verifique também a pasta de spam.
          </p>
          <Button variant="outline" fullWidth className="h-11" onClick={() => navigate('/login')}>Voltar ao login</Button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell titulo="Recuperar senha" subtitulo="Enviaremos um link de redefinição para seu e-mail">
      <form onSubmit={handleSubmit} className="space-y-4">
        {erro && <Alert variante="erro">{erro}</Alert>}

        <div>
          <Label htmlFor="email" obrigatorio>E-mail cadastrado</Label>
          <div className="relative">
            <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
            <Input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9" placeholder="seu@email.com" />
          </div>
        </div>

        <Turnstile onToken={setCaptchaToken} />

        <Button type="submit" loading={carregando} fullWidth className="h-11">Enviar link de redefinição</Button>
      </form>

      <p className="text-center text-sm text-slate-600 mt-6">
        Lembrou da senha?{' '}
        <Link to="/login" className="text-institutional font-semibold hover:underline">
          Voltar ao login
        </Link>
      </p>
    </AuthShell>
  );
}
